import React, { type FunctionComponent, useMemo } from 'react'
import { useImage } from 'react-image'
import MISSING_PRODUCT_IMAGE from '../../../assets/catalog/missing-product-image.png'
import { gridCellImageStyles } from '../utils/gridCellImage.styles'

export interface GridCellImageContentProps {
  src?: string
}

export const GridCellImageContent: FunctionComponent<GridCellImageContentProps> = ({
  src: inputImageSrc,
}) => {
  const srcList = useMemo(() => {
    if (!inputImageSrc) return [MISSING_PRODUCT_IMAGE]

    // Exclude inputImageSrc if it is currently undefined
    return [inputImageSrc, MISSING_PRODUCT_IMAGE]
  }, [inputImageSrc])

  const { src } = useImage({ srcList })

  return <img css={gridCellImageStyles} src={src} />
}
